
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacy-policies",
      function () {
        return require("private-next-pages/legal/privacy-policies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/privacy-policies"])
      });
    }
  